import { ActivityInputValues } from 'components/shared/activityInput/useActivityInput';
import { useEpisode } from 'context/episode';
import { useSelectedLocationEpisode } from 'context/locationEpisode';
import { Permission } from 'models/Profile';

import PriorityEscalationCheckbox from './PriorityEscalationCheckbox';

type Props = {
  permission: Permission;
  label: string;
  values: ActivityInputValues;
  setValues: React.Dispatch<React.SetStateAction<ActivityInputValues>>;
};

/**
 * The escalate / priority checkboxes, which are inherently episode-scoped.
 *
 * These live in their own component so that ActivityInput does not call `useEpisode` and
 * `useSelectedLocationEpisode` unconditionally. Both hooks THROW outside their providers
 * (`locationEpisode.tsx:110-112`), which made ActivityInput unusable on any surface without
 * an episode behind it — the clinical assessment slideout on an inbound referral being the
 * first. Rules of hooks mean the calls cannot simply be made conditional, so the
 * component that needs them only mounts when the caller asks for the checkboxes.
 */
export default function EpisodeScopedPriorityCheckbox({ permission, label, values, setValues }: Props) {
  const { episode } = useEpisode();
  const { locationEpisode } = useSelectedLocationEpisode();

  return (
    <PriorityEscalationCheckbox
      permission={permission}
      locationEpisode={locationEpisode!}
      episode={episode!}
      label={label}
      values={values}
      setValues={setValues}
    />
  );
}
